import React from "react";
import { CtaButton } from "./ui";
import { checkout } from "../data/content";
type Props = {
  label: string;
  className?: string;
};
export function CheckoutButton({
  label,
  className = ""
}: Props) {
  return <CtaButton href={checkout.url} className={className} data-id="element-39" data-mp="1rldj81pnrzhh">
      {label}
    </CtaButton>;
}